const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        period: {
          from: "From",
          to: "To",
          today: "Today",
          last7: "7 days",
          last30: "30 days"
        },
        cards: {
          inAttendance: "In service",
          waiting: "Waiting",
          onlineUsers: "Agents online",
          closed: "Closed tickets",
          messagesSent: "Messages sent",
          messagesReceived: "Messages received",
          newLeads: "New leads",
          avgAttendance: "Avg. service time",
          avgWait: "Avg. waiting time"
        },
        attendants: {
          title: "Agents",
          name: "Name",
          closed: "Closed tickets",
          avg: "Avg. service time",
          status: "Status (now)",
          online: "Online",
          offline: "Offline"
        },
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          kanban: "Kanban",
          tags: "Tags",
          schedules: "Schedules",
          tasks: "Tasks",
          calendar: "Calendar",
          internalChat: "Internal Chat",
          campaigns: "Campaigns",
          announcements: "Announcements",
          system: "System",
          companies: "Companies",
          plans: "Plans",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues & Chatbot",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          greeting: "Hello {{name}}, welcome to {{company}}!",
          user: {
            profile: "Profile",
            logout: "Logout",
          },
          darkMode: "Dark mode",
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      tags: {
        title: "Tags",
        buttons: {
          add: "Add tag"
        },
        table: {
          name: "Name",
          color: "Color",
          kanban: "Kanban column",
          position: "Order",
          actions: "Actions",
          yes: "Yes",
          no: "No"
        },
        confirmationModal: {
          deleteTitle: "Delete tag",
          deleteMessage: "The tag will be removed from all tickets. This action cannot be undone."
        },
        toasts: {
          deleted: "Tag deleted.",
          saved: "Tag saved."
        }
      },
      tagModal: {
        title: {
          add: "New tag",
          edit: "Edit tag"
        },
        form: {
          name: "Name",
          color: "Color",
          kanban: "Show as Kanban column",
          position: "Column order"
        },
        buttons: {
          cancel: "Cancel",
          ok: "Save"
        }
      },
      ticketTags: {
        placeholder: "Add tags",
        noOptions: "No tags registered"
      },
      kanban: {
        title: "Kanban",
        open: "Open",
        empty: "No tickets",
        pending: "Waiting",
        noLanes: "No tag is set as a Kanban column. Create one in Administration > Tags.",
        unassigned: "Unassigned"
      },
      schedules: {
        title: "Schedules",
        loadMore: "Load more",
        buttons: {
          add: "New schedule"
        },
        filters: {
          pending: "Pending",
          sent: "Sent",
          error: "Failed",
          all: "All",
          search: "Search contact or message"
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Send at",
          status: "Status",
          user: "Created by",
          actions: "Actions"
        },
        status: {
          pending: "Pending",
          sending: "Sending",
          sent: "Sent",
          error: "Error"
        },
        confirmationModal: {
          deleteTitle: "Delete schedule",
          deleteMessage: "The message will not be sent. This action cannot be undone."
        },
        toasts: {
          saved: "Schedule saved.",
          deleted: "Schedule deleted."
        },
        empty: "No schedules found."
      },
      scheduleModal: {
        title: {
          add: "Schedule message",
          edit: "Edit schedule"
        },
        form: {
          contact: "Contact",
          body: "Message",
          bodyHelp: "Use {{name}} to insert the contact name.",
          sendAt: "Send date and time"
        },
        buttons: {
          cancel: "Cancel",
          ok: "Schedule",
          okEdit: "Save"
        }
      },
      tasks: {
        title: "Tasks",
        buttons: {
          add: "New task"
        },
        filters: {
          mine: "Mine",
          open: "Open",
          overdue: "Overdue",
          done: "Done",
          all: "All",
          search: "Search task or contact"
        },
        table: {
          title: "Task",
          dueAt: "Due",
          priority: "Priority",
          assignedUser: "Assignee",
          contact: "Contact",
          actions: "Actions"
        },
        priority: {
          low: "Low",
          normal: "Normal",
          high: "High"
        },
        noDue: "No due date",
        overdue: "Overdue",
        complete: "Complete",
        reopen: "Reopen",
        confirmationModal: {
          deleteTitle: "Delete task",
          deleteMessage: "This action cannot be undone."
        },
        toasts: {
          saved: "Task saved.",
          deleted: "Task deleted.",
          assigned: "New task for you: {{title}}"
        },
        empty: "No tasks found.",
        loadMore: "Load more"
      },
      taskModal: {
        title: {
          add: "New task",
          edit: "Edit task"
        },
        form: {
          title: "Title",
          description: "Description",
          dueAt: "Due date",
          priority: "Priority",
          assignedUser: "Assignee",
          contact: "Contact (optional)",
          done: "Done"
        },
        buttons: {
          cancel: "Cancel",
          ok: "Save",
          delete: "Delete"
        }
      },
      calendar: {
        title: "Calendar",
        today: "Today",
        newTask: "New task",
        newSchedule: "New schedule",
        legend: {
          task: "Task",
          taskDone: "Completed task",
          schedule: "Schedule",
          scheduleSent: "Sent schedule",
          error: "Overdue / failed"
        },
        noEvents: "Nothing for this day.",
        more: "+{{count}} more",
        weekdays: "Sun,Mon,Tue,Wed,Thu,Fri,Sat"
      },
      internalChat: {
        title: "Internal Chat",
        newChat: "New conversation",
        noChats: "No conversations yet. Start one with a teammate.",
        selectChat: "Select a conversation or start a new one.",
        placeholder: "Type a message (Enter sends, Shift+Enter new line)",
        send: "Send",
        loadOlder: "Load older messages",
        you: "You",
        members: "{{count}} members",
        editGroup: "Edit group",
        leave: "Leave conversation",
        deleteGroup: "Delete group",
        confirmLeave: "You will no longer see this conversation.",
        confirmDelete: "The group and all messages will be deleted for everyone.",
        newMessage: "{{name}}: {{body}}",
        modal: {
          titleNew: "New conversation",
          titleEdit: "Edit group",
          users: "Members",
          groupTitle: "Group name",
          groupHelp: "Required when there is more than one member.",
          cancel: "Cancel",
          create: "Start",
          save: "Save"
        }
      },
      campaigns: {
        title: "Campaigns",
        buttons: {
          add: "New campaign"
        },
        empty: "No campaigns yet.",
        table: {
          name: "Campaign",
          status: "Status",
          progress: "Progress",
          when: "Start",
          actions: "Actions"
        },
        status: {
          draft: "Draft",
          scheduled: "Scheduled",
          running: "Sending",
          paused: "Paused",
          finished: "Finished",
          canceled: "Canceled"
        },
        actions: {
          edit: "Edit",
          start: "Start",
          pause: "Pause",
          resume: "Resume",
          cancel: "Cancel",
          report: "Report",
          delete: "Delete"
        },
        progress: "{{done}} of {{total}}",
        notStarted: "Not started",
        confirm: {
          startTitle: "Start the campaign?",
          startMessage: "Messages will be sent respecting the configured interval, hours and daily limit.",
          cancelTitle: "Cancel the campaign?",
          cancelMessage: "Pending sends will be discarded. This cannot be undone.",
          deleteTitle: "Delete the campaign?",
          deleteMessage: "The campaign and its send report will be deleted."
        },
        toasts: {
          saved: "Campaign saved.",
          deleted: "Campaign deleted."
        }
      },
      campaignModal: {
        title: {
          add: "New campaign",
          edit: "Edit campaign"
        },
        warning: "Bulk sending through unofficial WhatsApp may get the number banned. Use long intervals, few messages per day and only for people who already talk to you.",
        form: {
          name: "Campaign name",
          message: "Message {{n}}",
          messageHelp: "Use {{name}} for the contact name. Each send picks one variation at random.",
          addVariation: "Add variation",
          removeVariation: "Remove",
          target: "Recipients",
          targetAll: "Everyone who has talked to you",
          targetTags: "Contacts with tickets in these tags",
          targetContacts: "Chosen contacts",
          tags: "Tags",
          contacts: "Contacts",
          eligible: "{{count}} contact(s) will receive this campaign",
          eligibleHelp: "Only contacts who have messaged you are included.",
          scheduledAt: "Start at (optional)",
          scheduledHelp: "Empty: starts when you click Start.",
          minDelay: "Minimum interval (s)",
          maxDelay: "Maximum interval (s)",
          dailyLimit: "Daily limit",
          hourStart: "Send from (h)",
          hourEnd: "Until (h)",
          safety: "Sending safety"
        },
        buttons: {
          cancel: "Cancel",
          ok: "Save"
        }
      },
      campaignReport: {
        title: "Report: {{name}}",
        total: "Total",
        filters: {
          all: "All",
          pending: "Pending",
          sent: "Sent",
          error: "Failed",
          skipped: "Skipped"
        },
        table: {
          contact: "Contact",
          status: "Status",
          sentAt: "Sent at",
          detail: "Message / error"
        },
        status: {
          pending: "Pending",
          sent: "Sent",
          error: "Error",
          skipped: "Skipped"
        },
        close: "Close",
        loadMore: "Load more"
      },
      announcements: {
        title: "Announcements",
        buttons: {
          add: "New announcement"
        },
        empty: "No announcements right now.",
        priority: {
          low: "Low",
          normal: "Normal",
          high: "High"
        },
        inactive: "Inactive",
        by: "by {{name}} on {{date}}",
        newToast: "New announcement: {{title}}",
        confirmDelete: "Delete this announcement?",
        toasts: {
          saved: "Announcement saved.",
          deleted: "Announcement deleted."
        }
      },
      announcementModal: {
        title: {
          add: "New announcement",
          edit: "Edit announcement"
        },
        form: {
          title: "Title",
          text: "Text",
          priority: "Priority",
          active: "Active (visible to the team)"
        },
        buttons: {
          cancel: "Cancel",
          ok: "Save"
        }
      },
      companies: {
        title: "Companies",
        buttons: {
          add: "New company"
        },
        table: {
          name: "Company",
          plan: "Plan",
          usage: "Usage",
          dueDate: "Due date",
          status: "Status",
          actions: "Actions"
        },
        usage: "{{users}} user(s) · {{connections}} connection(s)",
        active: "Active",
        inactive: "Inactive",
        noPlan: "No plan",
        overdue: "Overdue",
        actions: {
          edit: "Edit",
          activate: "Activate",
          deactivate: "Deactivate",
          delete: "Delete"
        },
        confirmDeactivate: "Deactivate {{name}}? Nobody from it will be able to sign in until it is reactivated.",
        confirmDelete: "PERMANENTLY delete {{name}} and all of its data (contacts, tickets, messages, users)? This cannot be undone.",
        toasts: {
          saved: "Company saved.",
          deleted: "Company deleted."
        }
      },
      companyModal: {
        title: {
          add: "New company",
          edit: "Edit company"
        },
        form: {
          name: "Company name",
          plan: "Plan",
          dueDate: "Due date",
          email: "E-mail",
          phone: "Phone",
          document: "Tax ID",
          active: "Active",
          admin: "Company administrator",
          adminName: "Name",
          adminEmail: "Login e-mail",
          adminPassword: "Initial password"
        },
        buttons: {
          cancel: "Cancel",
          ok: "Save"
        }
      },
      plans: {
        title: "Plans",
        buttons: {
          add: "New plan"
        },
        table: {
          name: "Plan",
          users: "Users",
          connections: "Connections",
          queues: "Queues",
          campaigns: "Campaigns",
          actions: "Actions"
        },
        yes: "Yes",
        no: "No",
        confirmDelete: "Delete plan {{name}}?",
        toasts: {
          saved: "Plan saved.",
          deleted: "Plan deleted."
        }
      },
      planModal: {
        title: {
          add: "New plan",
          edit: "Edit plan"
        },
        form: {
          name: "Name",
          maxUsers: "Max users",
          maxConnections: "Max connections",
          maxQueues: "Max queues",
          useCampaigns: "Allows campaigns"
        },
        buttons: {
          cancel: "Cancel",
          ok: "Save"
        }
      },
      dueBanner: {
        soon: "{{company}}'s subscription is due in {{days}} day(s) ({{date}}).",
        today: "{{company}}'s subscription is due today.",
        overdue: "{{company}}'s subscription has been overdue since {{date}}. Please settle it to avoid suspension."
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        schedule: "Schedule message",
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_COMPANY_INACTIVE: "Company disabled. Please contact support.",
        ERR_COMPANY_NOT_FOUND: "Company not found.",
        ERR_COMPANY_INVALID_NAME: "Enter the company name (at least 2 characters).",
        ERR_COMPANY_INVALID_DATE: "Invalid due date.",
        ERR_COMPANY_ADMIN_REQUIRED: "Enter the company administrator's name, e-mail and password.",
        ERR_COMPANY_OWN: "You can't deactivate or delete your own company.",
        ERR_COMPANY_STILL_ACTIVE: "Deactivate the company before deleting it.",
        ERR_PLAN_NOT_FOUND: "Plan not found.",
        ERR_PLAN_INVALID_NAME: "Enter the plan name.",
        ERR_PLAN_INVALID_LIMIT: "Limits must be whole numbers between 0 and 9999.",
        ERR_PLAN_NAME_ALREADY_EXISTS: "A plan with this name already exists.",
        ERR_PLAN_IN_USE: "This plan is in use by a company.",
        ERR_PLAN_LIMIT_USERS: "The plan's user limit has been reached.",
        ERR_PLAN_LIMIT_CONNECTIONS: "The plan's connection limit has been reached.",
        ERR_PLAN_LIMIT_QUEUES: "The plan's queue limit has been reached.",
        ERR_PLAN_NO_CAMPAIGNS: "The company's plan doesn't include campaigns.",
        ERR_CAMPAIGN_NOT_FOUND: "Campaign not found.",
        ERR_CAMPAIGN_INVALID_NAME: "Name the campaign (2 to 120 characters).",
        ERR_CAMPAIGN_INVALID_MESSAGES: "Write 1 to 3 messages (up to 4096 characters each).",
        ERR_CAMPAIGN_INVALID_TARGET: "Invalid recipients.",
        ERR_CAMPAIGN_INVALID_DATE: "Invalid start date.",
        ERR_CAMPAIGN_INVALID_DELAY: "Invalid interval: minimum 20 seconds and the maximum can't be lower than the minimum.",
        ERR_CAMPAIGN_INVALID_LIMIT: "The daily limit must be between 1 and 1000.",
        ERR_CAMPAIGN_INVALID_HOURS: "Invalid hours: the end must be after the start.",
        ERR_CAMPAIGN_NOT_EDITABLE: "Only draft or scheduled campaigns can be edited.",
        ERR_CAMPAIGN_RUNNING: "Pause or cancel the campaign before deleting it.",
        ERR_CAMPAIGN_INVALID_ACTION: "This action isn't possible in the campaign's current status.",
        ERR_CAMPAIGN_NO_RECIPIENTS: "No eligible contacts for this campaign.",
        ERR_ANNOUNCEMENT_NOT_FOUND: "Announcement not found.",
        ERR_ANNOUNCEMENT_INVALID_TITLE: "Title must have 2 to 150 characters.",
        ERR_ANNOUNCEMENT_INVALID_TEXT: "Write the announcement text.",
        ERR_ANNOUNCEMENT_INVALID_PRIORITY: "Invalid priority.",
        ERR_CHAT_NOT_FOUND: "Conversation not found.",
        ERR_CHAT_INVALID_USERS: "Choose at least one valid member.",
        ERR_CHAT_INVALID_TITLE: "Name the group (at least 2 characters).",
        ERR_CHAT_INVALID_BODY: "Message is empty or too long.",
        ERR_TASK_NOT_FOUND: "Task not found.",
        ERR_TASK_INVALID_TITLE: "Title must have 2 to 200 characters.",
        ERR_TASK_INVALID_DATE: "Invalid due date.",
        ERR_TASK_INVALID_PRIORITY: "Invalid priority.",
        ERR_TASK_INVALID_STATUS: "Invalid status.",
        ERR_TASK_INVALID_USER: "Invalid assignee.",
        ERR_TASK_INVALID_CONTACT: "Invalid contact.",
        ERR_SCHEDULE_NOT_FOUND: "Schedule not found.",
        ERR_SCHEDULE_INVALID_BODY: "Write the message (up to 4096 characters).",
        ERR_SCHEDULE_INVALID_CONTACT: "Choose a valid contact (groups are not allowed).",
        ERR_SCHEDULE_INVALID_DATE: "Choose a future date and time.",
        ERR_SCHEDULE_ALREADY_SENT: "This schedule was already sent and cannot be changed.",
        ERR_TAG_INVALID_NAME: "Invalid tag name (at least 2 characters).",
        ERR_TAG_NAME_ALREADY_EXISTS: "A tag with this name already exists.",
        ERR_TAG_INVALID_COLOR: "Invalid color.",
        ERR_TAG_NOT_FOUND: "Tag not found.",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
      },
    },
  },
};

export { messages };
